import SamlGroupMappingsInternal, { componentName } from './SamlGroupMappingsInternal';

customElements.define(componentName, SamlGroupMappingsInternal);
